import get from "lodash/get";

import {
  GET_ACCESSIBILITY_DETAILS_LOADING,
  GET_ACCESSIBILITY_DETAILS_SUCCESS,
  GET_ACCESSIBILITY_DETAILS_FAILED,
  RESET_ACCESSIBILITY_DETAILS
} from "../actionTypeConstants/accessibility";

const initialState = {
  details: {},
  error: null,
  loading: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ACCESSIBILITY_DETAILS_LOADING:
      return {
        ...state,
        loading: true
      };

    case GET_ACCESSIBILITY_DETAILS_SUCCESS: {
      const data = get(action, ["result", "data"], {});
      return {
        ...state,
        loading: false,
        details: {
          ...state.details,
          ...data
        }
      };
    }

    case GET_ACCESSIBILITY_DETAILS_FAILED: {
      const errorStr = get(
        action,
        ["error", "response", "data", "message"],
        ""
      );

      return {
        ...state,
        loading: false,
        details: {},
        error: errorStr
      };
    }

    case RESET_ACCESSIBILITY_DETAILS: {
      return {
        ...state,
        details: {},
        error: null,
        loading: false
      };
    }

    default:
      return state;
  }
}
